import React from 'react';
import queryString from 'query-string';
import RemoveLoadingScreen from '@/pages/RemoveLoadingScreen';
import letter from '@assets/images/letter_open_blue.png';
import { Helmet } from 'react-helmet-async';
import useRouter from '@/hooks/useRouter';
import SolidButton from '@/components/Button/SolidButton';
import Card from '@/components/Card';
import classNames from 'classnames';

export default function Layout() {
  const { history, location } = useRouter();

  const { email } = queryString.parse(location.search);

  return (
    <div className="p-2 md:p-6">
      <Helmet>
        <title>Unauthorized</title>
      </Helmet>
      <RemoveLoadingScreen/>
      <Card
        border={false}
        className={classNames(
          'shadow-welcome max-w-screen-md mx-auto',
          'py-12 px-10',
          'space-y-8'
        )}
      >
        {/*<div*/}
        {/*  className={classNames(*/}
        {/*    '-mx-10 -mt-12 rounded-t-cs-10 h-40 w-100 overflow-hidden relative flex justify-center items-center'*/}
        {/*  )}*/}
        {/*  style={{ backgroundColor: 'rgb(255, 153, 0)'}}*/}
        {/*>*/}
        {/*  <img src={pattern} className="h-40 object-cover absolute z-0 opacity-50 bg-orange-500x" alt="Background pattern" />*/}
        {/*  <h1 className="text-white relative z-1 text-3xl text-center">*/}
        {/*    Welcome to CommunityShare!*/}
        {/*  </h1>*/}
        {/*</div>*/}
        <div>
          <div className="mb-12">
            <img className="h-48 m-auto" src={letter} alt="logo"/>
          </div>
          <h5 className="text-3xl font-semibold text-cs-gray-900 text-center max-w-xl m-auto">
            We&apos;ve sent a verification email to your inbox.
          </h5>
          <h6 className="text-base text-cs-gray-700 text-center mt-4 max-w-xl m-auto space-y-3">
            {email ? (
              <div>
                To activate your account, click the link in the email we just sent
                to <span className="font-semibold underline">{email}</span>. Then you&apos;ll be ready to explore the platform!
              </div>
            ) : (
              <div>
                To activate your account, click the link in the email we just sent. Then you&apos;ll be ready to explore the platform!
              </div>
            )}
            <div>
              Didn&apos;t get the email?
            </div>
            <div>
              Sometimes it hides — check your spam or junk folder just in case.
            </div>
          </h6>
        </div>
        <div className="flex justify-center">
          <SolidButton className="px-20" onClick={() => history.push('/login')}>
            I clicked the verification link
          </SolidButton>
        </div>
        <div className="flex items-center justify-end">
          <div className="text-base text-cs-gray-700 text-center max-w-xl m-auto">
            <div>
              Have questions? Reach out to us anytime
              at <a className="text-cs-orange-500" href="mailto:support@communityshare.org">support@communityshare.org</a>. We&apos;re here to help!
            </div>
          </div>
        </div>
      </Card>
      {/*<div className="bg-cs-yellow-500 fixed top-0 bottom-0 left-0 right-0 -z-1" />*/}
      {/*<div className="bg-cs-yellow-500 fixed top-0 bottom-0 left-0 right-0 -z-1" />*/}
      <div className="bg-gradient-to-b from-cs-yellow-100 to-cs-yellow-300 fixed top-0 bottom-0 left-0 right-0 -z-1" />
    </div>
  );
}
